// extracted by mini-css-extract-plugin
export default {"contents":"vF-z","sectionHeading":"wF-z"};